import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'alternative-pagination',
    templateUrl: './alternative-pagination.component.html',
    styleUrls: ['./alternative-pagination.component.scss']
})
export class AlternativePaginationComponent {

    @Input() page: number = 1;
    @Input() pages: number = 1;

    inputVal: number = 1;
    @Output() pageChangeEvent = new EventEmitter<number>();

    public pageChange(value: number) {
        this.pageChangeEvent.emit(value);
    }

    ngOnInit() {
        this.inputVal = this.page;
    }

    ngOnChange() {
        this.inputVal = this.page;
        console.log( this.page ); 
    }


    goToFirst() {
        this.pageChangeEvent.emit(1);
    }

    goToPrev() {
        this.pageChangeEvent.emit(this.page - 1);
    }

    goToNext() {
        this.pageChangeEvent.emit(this.page + 1);
    }

    goToLast() {
        this.pageChangeEvent.emit(this.pages);
    }

    onKeyUp( event: any  ) {
        let val = parseInt(event.target.value);

        
        console.log( val );
        if (val > this.pages) {
            val = this.pages;
        }

        if (val < 1) {
            val = 1;
        }

        this.pageChangeEvent.emit(val);
    }

    

    public pagesArray(count: number) {
        if (count >= 0) {
            console.log(new Array(count));
            return new Array(count);
        }
        return [];
    }

}